export const SESSION_CHANGED = "SESSION_CHANGED";
export const SESSION_DATA_LOADING = "SESSION_DATA_LOADING";
export const SESSION_DATA_READY = "SESSION_DATA_READY";
export const SESSION_DATA_FAILED = "SESSION_DATA_FAILED";
export const sessionChanged = (sessionId, external = false) => ({
  type: SESSION_CHANGED,
  payload: { sessionId, external },
});
export const sessionDataReady = (sessionId, user, company) => ({
  type: SESSION_DATA_READY,
  payload: { user, company },
  meta: { sessionId },
});
